'use strict';

goog.provide("Ntry.MazeResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.MazeResult = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryResultContainer');
        var title = Ntry.createElement('div', container, null, 'ntryResultTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = '닫기';

        var content = Ntry.createElement('div', container, null, 'ntryResultContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryResultLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryResultRightDiv');
        this._successContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');

        this._usedBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._usedBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._usedBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._limitBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._limitBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._limitBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._certDiv = Ntry.createElement('div', this._successContent, null, 'ntryResultCertDiv', 'ntryRemove');

        this._certDivLeft = Ntry.createElement('div', this._certDiv, null, 'ntryResultCertDivLeft');

        this._certNameLabel = Ntry.createElement('span', this._certDivLeft, null, 'ntryResultContentNameLabel');
        this._certNameLabel.innerHTML = Lang.Menus.jr_whats_ur_name;

        this._certNameInput = Ntry.createElement('input', this._certDivLeft, null, 'ntryResultContentNameInput');
        this._certNameInput.type = "text";

        this._certLink = Ntry.createElement('div', this._certDiv, null, 'ntryResultContentCert', 'maze');
        this._certLink.innerHTML = Lang.Menus.jr_down_cert;

        this._failContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = Ntry.createElement('span', this._failContent, null, 'ntryResultFailCauseSpan');

        this._essentialBlocks = Ntry.createElement('div', this._failContent, null, 'ntryResultEssentialBlocks');

        this._replayButton = Ntry.createElement('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = Lang.Menus.replay;

        this._nextButton = Ntry.createElement('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = Lang.Menus.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.goToUrl(that._nextLink);
        });
    };

    p.update = function() { };

    p.randomString = function(len) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        this._leftImg.removeClasses();

        var reg = /lang=../;
        var lang = document.cookie.match(reg)[0].split('lang=')[1];

        if (lang == 'ko') {
            this._leftImg.addClass('ntryResultLeftImg');
        } else {
            this._leftImg.addClass('ntryResultLeftImg');
            this._leftImg.addClass('en');
        }


        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._nextLink = '/we/maze#!/'+(stageId+1);

        if (!window.mazeuserkey) {
            window.mazeuserkey = this.randomString(8);
            var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            $.ajax({
                method: "POST",
                url: "/api/maze/user",
                data: {
                    key: window.mazeuserkey
                },
                headers: {'csrf-token': csrfToken},
                cache: false
            });
        }

        this._certNameInput.bindOnClick(function() {
            self._certNameInput.focus();
        });

        this._certLink.bindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.cparty_insert_name);
                self._certNameInput.focus();
            } else {
                window.location.href = '/we/maze#!/c/c/'+window.mazeuserkey+'/'+username
            }
        });

        if (success) {
            var isEssentialUsed = this.inspectEssential();
            if (isEssentialUsed) {
                this.success(stageId);
            } else {
                this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            this.fail(stageId, cause);
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        var essentialBlock =
            Ntry.configManager.getConfig('essentialBlockInfo');

        if (essentialBlock === undefined) return true;

        var esBlocks = essentialBlock.blocks.slice(0);

        var code = getUserCode();
        if (_.isEmpty(code)) return false;

        var threads = code.getThreads();
        if (_.isEmpty(threads)) return false;

        for(var i=0, len=threads.length; i<len; i++) {
            var thread = threads[i];
            var head = thread.getFirstBlock();  //첫번째 Thread (jrstart)

            if (!head || !head._schema.event) continue;

            var blocks = thread.getBlocks();

            for (var j=0; j<blocks.length; j++) {
                var block = blocks[j];
                var type = block.type;

                var index = esBlocks.indexOf(type);
                if (index > -1) esBlocks.splice(index, 1);
                var statement = block.statements[0];
                if (statement) {
                    var innerBlocks = statement.getBlocks();
                    for (var k=0; k<innerBlocks.length; k++) {
                        var innerBlock = innerBlocks[k];
                        type = innerBlock.type;

                        index = esBlocks.indexOf(type);
                        if (index > -1) esBlocks.splice(index, 1);
                    }
                }

                if (esBlocks.length === 0) return true;
            }
        }

        return esBlocks.length === 0;
    };

    function getUserCode() {
        var entities = Ntry.entityManager.
                getEntitiesByComponent(Ntry.STATIC.CODE);

        var entity = entities[Object.keys(entities)[0]];

        if (entity)
            return Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.CODE).code;
    };


    p.success = function(stageId) {
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt = 0;
        var code = getUserCode();
        if (code) {
            var startThread = code.getEventMap('start')[0].getThread();
            var usedBlockCnt = startThread.countBlock();
            var defineThread = code.getEventMap('define');
            if (defineThread && defineThread[0]) {
                defineThread = defineThread[0].getThread();
                usedBlockCnt += defineThread.countBlock();
            }
        }

        if (stageId <= 6)
            this._leftImg.addClass('ntryResultSuccess1Img');
        else if (stageId <= 14)
            this._leftImg.addClass('ntryResultSuccess2Img');
        else
            this._leftImg.addClass('ntryResultSuccess3Img');

        // this._replayButton.removeClasses();

        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');

        if (stageId === 20) {
           // this._replayButton.addClass('ntryResultFailAndReply');
            this._replayButton.ntryRemove();
        }
        else
            // this._replayButton.addClass('ntryResultReplayButton');
           this._replayButton.addClass("ntryResultReplayButtonFailed");

        this._usedBlockCnt.innerHTML = usedBlockCnt;
        this._limitBlockCnt.innerHTML = limitBlockCnt;
        if (usedBlockCnt === limitBlockCnt) {
            this._usedBlockPrefix.innerHTML = Lang.Menus.perfect;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_using_blocks;
            this._limitBlockCnt.ntryRemove();
            this._limitBlockPrefix.ntryRemove();
            this._limitBlockSuffix.ntryRemove();
        } else if (usedBlockCnt < limitBlockCnt) {
            this._usedBlockPrefix.innerHTML = Lang.Menus.awesome;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_go_to_next;
            if (stageId === 20)
                this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_and_cert;
            this._limitBlockCnt.ntryRemove();
            this._limitBlockPrefix.ntryRemove();
            this._limitBlockSuffix.ntryRemove();
            this._replayButton.ntryRemove();
        } else {
            this._usedBlockPrefix.innerHTML = Lang.Menus.good;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_using_blocks;
            this._limitBlockPrefix.innerHTML = Lang.Menus.but;
            this._limitBlockSuffix.innerHTML = Lang.Menus.try_again;
            this._limitBlockCnt.ntryShow('ntryShowInlineBlock');
            this._limitBlockPrefix.ntryShow('ntryShowInline');
            this._limitBlockSuffix.ntryShow('ntryShowInline');
        }

        if (stageId === 20) {
            this._certDiv.ntryShow();
            this._nextButton.ntryRemove();
        } else {
            this._nextButton.ntryShow();
        }

        if (Entry.mainWorkspace) {
            var playerData = NtryData.player[stageId];
            playerData.code = Entry.mainWorkspace.board.code.toJSON();
        }
        this._successContent.ntryShow();
        this._failContent.ntryRemove();

    };

    p.fail = function(stageId, cause) {
        var theme = 1;

        if (stageId <= 6)
            theme = 1;
        else if (stageId <= 14)
            theme = 2;
        else
            theme = 3;

        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.cause_msgs_1,
            Lang.Menus.cause_msgs_2,
            Lang.Menus.cause_msgs_3,
            Lang.Menus.cause_msgs_4,
            Lang.Menus.cause_msgs_5
        ]

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();

        switch (cause) {
            case Ntry.STATIC.JUMP:
                causeString = causeMsgs[1];
                causeStyle = 1;
                break;

            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[4];
                causeStyle = 1;
                break;

            case Ntry.STATIC.WALL_CRASH:
                causeString = causeMsgs[0];
                causeStyle = 2;
                break;

            case Ntry.STATIC.BEE_ATTACK:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.ELECTRIC_SHOCK:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.SLIP:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.ESSENTIAL_REQUIRED:
                causeString = causeMsgs[3];
                causeStyle = 1;
                this.renderBlocks(stageId);
                break;

            default:
                causeString = causeMsgs[4];
                causeStyle = 1;

        }

        var imageClass = 'ntryResultFail_'+theme+'_'+causeStyle;

        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.removeClasses();
        this._replayButton.addClass("ntryResultFailAndReply");
    };

    p.renderBlocks = function(stageId) {
        var type = 5;
        if (stageId === 7 || stageId === 8)
            type = 1;
        else if (stageId === 9)
            type = 2;
        else if (stageId >= 10 && stageId <= 12)
            type = 3;
        else if (stageId === 13 || stageId === 14)
            type = 4;

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.addClass("ntryResultEssentialBlocks");
        this._essentialBlocks.addClass("ntryResultEssentialBlock_"+type);
    };

})(Ntry.MazeResult.prototype);
